import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export default function TextFieldMultiDisabledComponent({ propsData, name }) {
  const { handleChange, values } = propsData;

  const sendDataToParent = (event) => {
    handleChange(event);
  };

  return (
    <Box
      component="form"
      sx={{
        "& .MuiTextField-root": { width: "100%" },
      }}
      noValidate
      autoComplete="off"
    >
      <TextField
        onChange={sendDataToParent}
        value={values[name]}
        name={name}
        style={{ height: "120px" }}
        multiline
        minRows={1.85}
        maxRows={1.85}
        disabled
      />
    </Box>
  );
}
